import React from "react";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import StatusBackground from "src/components/StatusBackground";
import { ContentWrapper, OuterBox, InnerBox } from "./ConfirmationLayout";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

/**
 * ConfirmationPage - A DRY component for confirmation pages with consistent layout
 *
 * @param {boolean} loading - Show loading spinner
 * @param {string} loadingMessage - Message to show while loading
 * @param {boolean} error - Whether there's an error state
 * @param {string} title - Page title
 * @param {string} icon - Path to icon image (legacy support) or null to use React Icons based on error state
 * @param {ReactNode} children - Content to display in the confirmation box
 */
const ConfirmationPage = ({
  loading = false,
  loadingMessage = "Processing...",
  error = false,
  title,
  icon = null,
  children,
}) => {
  // Determine which icon to show
  const renderIcon = () => {
    // If a custom icon path is provided (legacy), use ResponsiveImage
    if (icon && typeof icon === 'string') {
      return <ResponsiveImage src={icon} alt="status icon" />;
    }

    // Otherwise use React Icons based on error state
    if (error) {
      return <StyledWarningIcon />;
    } else {
      return <StyledCheckIcon />;
    }
  };

  return (
    <StatusBackground>
      <ContentWrapper>
        {loading ? (
          <LoaderWrapper>
            <Spinner animation="border" variant="light" />
            <p>{loadingMessage}</p>
          </LoaderWrapper>
        ) : (
          <>
            {title && <h3>{title}</h3>}
            <OuterBox>
              <InnerBox
                className={`email-success ${error ? "error" : "success"}`}
              >
                {renderIcon()}
                {children}
              </InnerBox>
            </OuterBox>
          </>
        )}
      </ContentWrapper>
    </StatusBackground>
  );
};

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--white);
  text-align: center;
`;

const StyledCheckIcon = styled(FaCheckCircle)`
  font-size: 40px;
  color: #28a745;
  margin: 10px 0 20px;
`;

const StyledWarningIcon = styled(FaExclamationTriangle)`
  font-size: 40px;
  color: #ff8c00;
  margin: 10px 0 20px;
`;

export default ConfirmationPage;
